var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "admin-content-area",
        attrs: { id: "page-content-wrapper" }
      },
      [
        _c("div", { staticClass: "container-fluid xyz" }, [
          _c(
            "div",
            {
              staticClass: "page-header-top-container",
              staticStyle: { "padding-bottom": "20px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "page-name",
                  staticStyle: { "font-size": "26px", "font-weight": "bold" }
                },
                [_vm._v("Consolidated QC checklist")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "admin-page-content",
              staticStyle: { "margin-left": "20px" }
            },
            [
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Vehicle Servicing / Maintenance, check/complete the following\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    Service Sheet is complete with all requirements filled out in full\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Onboard maintenance requirements reviewed and intervals reset (if equipped)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Brake and tyre wear values reviewed and measurements recorded\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Vehicle defect list reported and urgency of safety related concerns highlighted\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Turntable jaw and mounting fasteners have been adjusted/inspected\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Service sticker installed (filled out with correct kms & date, clean and positioned correctly)\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Brake Maintenance & Repairs, check/complete the following:\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    Disc brakes: Visually inspect fitment of new pads and pad securing circlip, ensuring correct installation orientation (sealant may be applied to circlip to prevent dislodging)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Wheel nuts tensioned to required torque setting\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Brake wear values reset in maintenance system on applicable vehicle\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Brake roller test completed post repair and reviewed by supervisor (review results for correct wheel bearing, brake adjustment and function)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Perform short road-test, inspect hub temperatures and visually inspect for oil or air leaks\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Tail Shaft Fitment, check/complete the following:\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    Tail shaft visually inspected and free of damage or impact\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Flange connections cleaned to ensure positive mating surfaces\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Shaft is in-phase and if the slip joint was separated, that it is clean and lubricated prior to fitment\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Tail shaft fastening inspected to be serviceable (note: recommended Freightliner “Spicer” universal joint fasteners are single use)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Fasteners installed to manufacturer’s specified torque utilising calibrated tension wrench\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Perform short road-test, monitoring for driveline vibration\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    After road-test, fasteners should re-torqued and movement detection paint applied to bolt heads as completion indicator\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Cooling System Repairs, check/complete the following:\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    CAUTION: Be careful opening cooling system when circuit is at increased temperature\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Coolant type is correct and tested in serviceable condition\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Coolant bleed procedure completed with no level warnings displayed on dash\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Cooling system maintenance has been updated (if equipped with on-board maintenance system)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Coolant circuit integrity checked post-repair via pressure test or by increasing system to operating temperature\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    If repair required cooling system temperature increase, ensure top and bottom hose temperature checked to confirm coolant flow\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Engine Tune Up, check/complete the following:\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    Engine tune-up procedure completed by competent technician who has been trained on specific engine variant\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    All adjustment and rocker gear securing fasteners / jam nuts are torqued to manufacturer’s specification with calibrated torque wrench (note: fasteners should be marked upon being tensioned, once adjustment is completed, everything should be re-checked for correct tension)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    Rocker cover / intermediate plate gasket replaced if required\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", "margin-bottom": "15px" } },
                [
                  _vm._v(
                    "\n                Towed-In Vehicles, check/complete the following:\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", { staticStyle: { "padding-left": "15px" } }, [
                _c("li", [
                  _vm._v(
                    "\n                    If tail shaft has been removed, ensure it is visually inspected, confirming that it is free of damage, in-phase and that fasteners installed correctly (see Tail Shaft Fitment list above)\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    If axle shafts have been removed, ensure correct remove and refit procedure has been carried out, including cleaning of surfaces and replacement of seals when required\n                "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                    If brake boosters have been unwound, ensure they are wound back into service position (brake roller test recommended upon completion if equipment is available)\n                "
                  )
                ])
              ])
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dcce560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dcce560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QC/TaskList.vue
// module id = null
// module chunks = 